import * as React from "react"

import { Action, ActionType } from "@tenforce/toolbox-button-push-react"
import { Cell, CellType, RowContent } from "@tenforce/toolbox-table-react"

import { connect } from "react-redux"
import { DispatchProps, mapDispatchToProps } from "../../actions"
import { formatString } from "../../../../util/Strings"
import { getNextPageSize, NextPageSize } from "../../selectors"
import { GlobalState } from "../../../../store"
import OldUIContext from "../../../../olduicontext"
import { Labels } from "../../../../util/Translations"
import { ConceptsInfo } from "../../index"

type StateProps = ConceptsInfo & NextPageSize

type Props = StateProps & DispatchProps

export class LoadMore extends React.Component<Props> {
    static contextType = OldUIContext
    context: React.ContextType<typeof OldUIContext>

    render(): JSX.Element {
        const { LoadNMore } = Labels
        const { nextPageSize } = this.props
        const loadMoreLabel = formatString(LoadNMore, nextPageSize)

        return (
            <RowContent key="loadmore">
                <Cell type={CellType.action}>
                    <Action
                        actionType={ActionType.block}
                        extraClasses="tw-px-6"
                        onClick={this.loadMore}
                        data-ft-component="loadMore"
                    >
                        {loadMoreLabel}
                    </Action>
                </Cell>
            </RowContent>
        )
    }

    loadMore = (): void => {
        const { loadMoreConcepts } = this.props
        loadMoreConcepts()
    }
}

const mapStateToProps = (state: GlobalState): StateProps => ({
    ...state.conceptsPage.conceptsInfo,
    nextPageSize: getNextPageSize(state.conceptsPage.conceptsInfo),
})

export default connect(mapStateToProps, mapDispatchToProps)(LoadMore)
